import { render, staticRenderFns } from "./IncentiveForm.vue?vue&type=template&id=1ab4b477"
import script from "./IncentiveForm.vue?vue&type=script&lang=js"
export * from "./IncentiveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports